import { Voucher } from "@/models";
import { imprimirVoucher } from "@/shareds/venda-shareds";

export class VoucherUseCase {
	imprimirVoucher =  async (voucher: Voucher): Promise<any> =>
		imprimirVoucher(voucher)
}